export const PORTAL_APP_SUBSCRIPTION_PATH = 'https://portal.zopup.online/tenant/subscriptions';